import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react';

const LOGO_URL = "/logo.png";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img 
                src={LOGO_URL} 
                alt="Artsy Craftsy" 
                className="h-16 w-auto object-contain bg-white/10 rounded-lg p-1"
              />
            </div>
            <p className="text-slate-400 font-body">
              Inspiring creativity in children through art education. After-school art club for Years 1-6.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-xl font-bold mb-4 text-yellow-400">Quick Links</h4>
            <ul className="space-y-2 font-body">
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/art-club" className="text-slate-400 hover:text-white transition-colors">
                  Art Club
                </Link>
              </li>
              <li>
                <Link to="/workshops" className="text-slate-400 hover:text-white transition-colors">
                  Workshops
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-slate-400 hover:text-white transition-colors">
                  Materials Shop
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-xl font-bold mb-4 text-yellow-400">Contact Us</h4>
            <ul className="space-y-3 font-body">
              <li className="flex items-center gap-2 text-slate-400">
                <Mail className="w-4 h-4 text-blue-400" />
                hello@artsycrafsy.art
              </li>
              <li className="flex items-center gap-2 text-slate-400">
                <Phone className="w-4 h-4 text-blue-400" />
                07123 456789
              </li>
              <li className="flex items-start gap-2 text-slate-400">
                <MapPin className="w-4 h-4 text-blue-400 mt-1" />
                <span>Primary Schools across London</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-heading text-xl font-bold mb-4 text-yellow-400">Follow Us</h4>
            <div className="flex gap-3">
              <a 
                href="#" 
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-pink-500 transition-colors"
                data-testid="social-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors"
                data-testid="social-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
            <p className="text-slate-500 text-sm mt-4 font-body">
              Share your child's artwork with #ArtsyCraftsy
            </p>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8">
          <div className="flex flex-wrap justify-center gap-4 mb-4 font-body text-sm">
            <Link to="/policies" className="text-slate-400 hover:text-white transition-colors">Terms & Conditions</Link>
            <span className="text-slate-700">|</span>
            <Link to="/policies" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</Link>
            <span className="text-slate-700">|</span>
            <Link to="/policies" className="text-slate-400 hover:text-white transition-colors">Cookie Policy</Link>
            <span className="text-slate-700">|</span>
            <Link to="/policies" className="text-slate-400 hover:text-white transition-colors">Materials Policy</Link>
          </div>
          <p className="text-center text-slate-500 font-body">&copy; {new Date().getFullYear()} Artsy Craftsy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
